import React from "react";
import { Button, Input } from "reactstrap";

const PaymentMethod = ({ method, index, amount, onChange, onPay, onPayTotal, onKeyDown, canPay, remainingBalance, inputRef }) => (
  <div className="d-flex align-items-center mb-2 p-2 border rounded" style={{ backgroundColor: "#333" }}>
    <div className="flex-grow-1 me-2">
      <strong style={{ color: "white", fontSize: "13px" }}>{method.name}</strong>
    </div>
    <div className="me-2" style={{ width: "100px" }}>
      <Input
        type="number"
        placeholder="Amount"
        value={amount}
        onChange={onChange}
        onKeyDown={onKeyDown}
        step="0.01"
        min="0"
        size="sm"
        data-payment-index={index}
        style={{ fontSize: "12px" }}
        innerRef={inputRef}
      />
    </div>
    <div className="d-flex gap-1">
      <Button
        color={method.color}
        onClick={onPay}
        disabled={!canPay}
        size="sm"
        style={{ fontSize: "11px", padding: "4px 8px" }}
      >
        Pay
      </Button>
      <Button
        color="success"
        onClick={onPayTotal}
        disabled={remainingBalance <= 0}
        size="sm"
        style={{ fontSize: "10px", padding: "4px 6px" }}
      >
        Total
      </Button>
    </div>
  </div>
);

export default PaymentMethod;